// 登陆页
const login = {
    'key_boyanIoTqiyeguanlipingtai': 'IoT Application Mgmt Portal',
    'key_xuanzechangjing':'Choose Scene',
    'key_zanwuquanxian': 'NO permissions',
    'key_zhanghao': 'User name',
    'key_mima': 'Password',
    'key_denglu': 'Login',
    'key_jizhuzhanghaomima': 'Remember',
    'key_wangjimima': 'Forgot password ?',
    'key_quzhuce':'To register',
    'key_xitongyichang': 'System exceptions',
    'key_bushikehu': 'Not a customer?',
    'key_mianfeishiyong': 'Free trial ',
    'key_qingshuruyonghuming': 'Please enter a user name.',
    
    //注册页
    'key_zhuce': 'Register',
    'key_zhucechenggong': 'Registration Successful',
    'key_gongsimingcheng': 'Company Name',
    'key_suozaiquyu': 'Area',
    'key_changjingleixing': 'Scene',
    'key_lianxirenmingcheng': 'Contact Name',
    'key_lianxidianhua': 'Contact Number',
    'key_youxiang': 'E-mail',
    'key_zhiweimingcheng':'Job Title',
    'key_youxiangyanzhengma': 'Mailbox Verification Code',
    'key_zhanghumima': 'Password',
    'key_querenmima': 'Confirm Password',
    'key_yanzhengmafasongdaoyouxiang': 'Verification code is sent to your mailbox',
    'key_qingquerenmima': 'Please confirm password',
    'key_fasongyanzhengma': 'Send Verification Code',
    'key_qingshuruzhengqueyouxianggeshi': 'Please enter the correct mailbox format',
    'key_qingshuruzhengquemimageshi': 'Please enter the correct password format',
    'key_mimabuyizhi': 'Two passwords are inconsistent',
    //注册成功
    'key_nindexinxiyitijiao':'Your information has been submitted',
    'key_yigegongzuorineiwancheng':'One working day to complete the audit',
    'key_ruyouwentiqinglianxi':'If there are any questions, please contact 400-000-6282',
    'key_tijiaochenggong':'Submit successfully!',

    //找回密码
    'key_zhaohuimima': 'Retrieve password',
    'key_forgetwarning1': 'Please fill in the account number you need to retrieve and follow the prompt steps to retrieve the password.',
    'key_xinmima': 'New password',
    'key_mimachongzhichenggong': 'Congratulation,password has been reseted',
    'key_zhijiedenglu': 'Login',
    'key_mimaxiugaichenggong': 'Change password successfully',
}

// 头部导航栏
const headerLang = {
    'key_xiangmugaikuang': 'Project Overview',
    'key_shebeiguanli': 'Device Management',
    'key_nenghaoguanli': 'Energy Consumption',
    'key_baojingguanli': 'Alarm Management',
    'key_weibaoguanli': 'Maintainace Management',
    'key_yonghuguanli': 'User Management',
    'key_yunweitongzhi': 'Operation Management',
    'key_kongzhitai': 'Console',
    'key_gerenxinxi': 'Personal Info',
    'key_xiugaimima': 'Change Password',
    'key_gengxingongsixinxi': 'Change Company Info',
    'key_gexingpeizhi': 'Theme Setting',
    'key_jueseguanli': 'Role Management',
    'key_tuichu': 'Log Out',
    // 默认值
    'key_zuhuguanlihoutai': 'Iot SAAS Plantform',
    'key_zanwuyingyong': 'No Apps',
    'key_xingqiyi': 'Mon',
    'key_xingqier': 'Tue',
    'key_xingqisan': 'Wen',
    'key_xingqisi': 'Thu',
    'key_xingqiwu': 'Fri',
    'key_xingqiliu': 'Sat',
    'key_xingqiri': 'Sun',
    //空气质量
    'key_huanjingshuju': 'Environment Quality',
    'key_shuxing': 'Attribute',
    'key_kongqizhiliang': 'Air Quality',
    'key_sheweimoren': 'Default',
    'key_wendu': 'Temperature',
    'key_shidu': 'Humidity',
}

// 左侧导航栏
const Aside = {
  // 设备
  'key_shebeizonglan': '设备总览',
  // 能耗
  'key_zongnenghaotongji': '总能耗统计',
  'key_yongshuitongji': '用水统计',
  'key_yongdiantongji': '用电统计',
  // 报警
  'key_shishibaojing': '实时报警',
  'key_baojingfenxi': '报警分析',
  'key_baojingdingyi': '报警定义',
  // 维保
 
 
  
 
  
  // 用户
  'key_shouye': '员工管理',
  'key_shouye': '员工列表',
  // 运维
  'key_shouye': '发布历史',
  'key_shouye': '发布通知',
  // 空间
  'key_shouye': '组织架构配置',
  'key_shouye': '空间配置',
  'key_shouye': '岗位类型配置',
  'key_shouye': '水电费配置',
  'key_shouye': 'Dashboard',
  'key_yuangongguanli': 'User Management',
  // 'key_yuangongshouquanjilu': 'User Access History',
  // 'key_fangkeguanli': 'Visit Management',
  // 'key_fangkexingcheng': 'Visit Detail',
  // 'key_fangkerenzhengjilu': 'Visitor Access History',
  // 'key_huiyishiguanli': '会议室管理',
  // 'key_gongweiguanli': '工位管理',
  'key_shebeiguanli': 'Device Management',
  'key_xitongshezhi': 'Settings',
  'key_qiyeziliao': '企业资料',
  'key_shezhi': 'Settings',
  'key_xiugaimima': 'Change Password',
  'key_gerenxinxi': 'Personal Information',
  'key_tuichu': 'Logout'
}

//公用
const common = {
    //概念
    'key_baojing':'Alarms',
    'key_shebei':'Device',

    //按钮类
    'key_zanwushuju':'No Data',
    'key_shangyibu':'Prev',
    'key_xiayibu':'Next',
    'key_queren':'Confirm',
    'key_quxiao':'Cancel',
    'key_guanbi':'Close',
    'key_jieshu':'Finish',
    'key_wancheng':'Finish',
    'key_tijiao':'Submit',
    'key_yulan':'Preview',
    'key_quanbu':'All',
    'key_zidingyi':'Customize',
    'key_chakan': 'Detail',
    'key_xuhao': 'Index', 
    'key_daochubiaogemingxi':'Export Excel',
    'key_daochushuju':'Export data', 

    //区域类
    'key_weizhi':'Position',
    'key_quyu':'Area',
    'key_xuanzequyu':'Choose Area',

    //比例类+数量类
    'key_bili':'Rate',
    'key_leixing':'Category',
    'key_zaixianshu':'Online',
    'key_zaixianlv':'Online Rate',
    'key_qiyonglv':'Enable rate',
    'key_guzhanglv':'Failure rate',
    'key_chulilv':'Treatment rate',  
    'key_chenggonglv':'Success Rate',
    'key_pingjunzhi':'average',

    //时间段
    'key_shijian':'Time',
    'key_kaishiriqi':'start time',
    'key_jieshuriqi':'end time',
    'key_riqixuanze':'Choose Date',
    'key_Jan':'Jan',
    'key_Feb':'Feb',
    'key_Mar':'Mar',
    'key_Apr':'Apr',
    'key_May':'May',
    'key_Jun':'Jun',
    'key_Jul':'Jul',
    'key_Aug':'Aug',
    'key_Sep':'Sep',
    'key_Oct':'Oct',
    'key_Nov':'Nov',
    'key_Dec':'Dec',
    'key_xuanzeyihuoduogeyuefen':'Choose at least one month',
    'key_zuotian':'yesterday',
    'key_jinqitian':'Last 7 days',
    'key_jinsanshitian':'Last 30 days',
    'key_jinsangeyue':'Last 3 months',
    'key_jinbannian':'Last half year',
    'key_benzhouqi':'This period',
    'key_bishangzhouqi':'Compare to last period',
    'key_shangzhouqi':'Last period',
    'key_zhouqi':'Frequency',
    'key_shijianduan':'Time-range',
    'key_quanshijianduan':'Full time period',
    'key_tongbishangzhou':'Compare to last week',

    //单位类
    'key_danwei':'Unit',
    'key_shuliang':'Amount',
    'key_tai':' ',
    'key_tiao':'',
    'key_ge':' ',
    'key_fen':' ',
    'key_tian':'D',
    'key_yue':'Month',
    'key_xiaoshi':'h',
    'key_fenzhong':'min',
    'key_miaozhong':'s',
    
    'key_yuan':'Yuan',
    'key_wanyuan':'10G(Yuan)', 
    'key_wan':'ten thousand;',

    //状态
    'key_zhuangtai': 'Status',
    'key_zhengchang': 'Normal',
    'key_yichang': 'Error',
    'key_yiqiyong':'Enable', 
    'key_weiqiyong':'Not Enable', 
    'key_weichuli':'Unhandled', 
    'key_chulizhong':'Processing', 
    'key_yichuli':'Handled', 
    'key_zaixian':'Online', 
    'key_lixian':'Offline', 
    'key_lianghao':'Good', 
    'key_yanzhong':'Serious', 
    'key_zhongdeng':'Medium', 
    'key_yiban':'Normal', 
    'key_jiaocha':'Bad', 
    'key_weizhixing':'Unexecuted',
    'key_yiwancheng':'Completed',
    'key_weiwancheng': 'Incompleted',
    'key_zhixingzhong':'Progressing',

    //placeholder 类
    'key_qingshuru':'Please input ',
    'key_qingxuanze':'Please select ',
    'key_qingshangchuan':'Please upload',

    //提示类
    'key_cicaozuojiangshanchugairenwu':'This operation will delete the task. Do you want to continue?', 
    'key_yiquxiaoshanchu':'Delete canceled',
    'key_tianjiarenwuchenggong':'Add task successfully',
    'key_tianjiarenwushibai':'Add task failed',
    'key_bianjirenwuchenggong':'Edit task successfully',
    'key_bianjirenwushibai':'Edit task failed',
    'key_shanchuchenggong':'Delete successfully',
    'key_xiugaichenggong':'Update successfully',
    'key_tianjiachenggong':'Add successfully',
    'key_tianjiayingyonghouzaicaozuo':'Please add application first',
    'key_quedingshanchugangweileixing':'Are you sure you want to delete this job type?',
    'key_changjingtishi1':' is expired',
    'key_changjingtishi2':' is expired and banned',
    'key_changjingtishi3':' is banned',
    'key_changjingtishi4':'if have any questions please dail:400 000 6282',
    'key_qingwanshanbiaogexinxi':'Pleas make sure form is complete',  
    'key_xinjianjuesechenggong':'Creat role successfully',  
    'key_bianjijuesechenggong':'Update role successfully',
}

// 项目概览
const projectOverviewLang = {    
    'key_qiyongbili':'Device enable Rate',
    'key_zaixianbili':'Device online Rate',
    'key_shebeibilifenxitu':'Device Distribution Ratio',
    'key_shebeixiaoxizongliang':'Device/Messages total amount',
    'key_shebeizongshu':'Total amount of devices',
    'key_xiaoxizongshu':'Total amount of messages',
    'key_gongdanxiangyingshijian':'Order response time',
    'key_pingjunshijian':'Average time',
    'key_zuichangshijian':'Maximum time',
    'key_zuiduanshijian':'Minimum time',
    'key_shebeibaojing':'Device Alarms',
    'key_shebeilixian':'Device offline',
    'key_shebeizaixian':'Device online',
    'key_gongdandaizhixing':'Orders to be implemented',
    'key_baojingshujuchuli':'Alarm Data Process',
    'key_daichuli':'To be Implemented',
    'key_yichuli':'Implemented',
    'key_jinyigeyuejingbaoshuju':'Alarm data(Last Month)',
    'key_jinyigeyuenenghaoshuju':'Energy Consumption data(Last Month)',
    'key_quanpingmoshi':'Full-screen Mode',
    'key_shebeijiankang':'Device Health',
    'key_zongtiyunxing':'Running Status',
    'key_danxiangmujiashicang':'Current App control cabin',
    'key_quanxiangmujiashicang':'All App control cabin',
    //全项目驾驶舱页面
    
    'key_jiashicang':'Control cabin',
    'key_quanbushebeishuliang':'Total number of equipment',
    'key_quanbuxiaoxishuliang':'Total number of messages',
    'key_nenghaoqushitu':'Energy consumption trend chart',
    'key_baojingqushitu':'Alarm trend chart',
    'key_yingyongfenbu':'Application of distribution',
    'key_jieruyingyongzongshu':'Total access applications',
    'key_baojingbilitu':'Alarm scale',
    'key_yingyongdizhi':'Application address',
    'key_yingyongchuanjianshijian':'Application creation time',
    'key_shebeishuliang':'Quantity of device',
    'key_xiaoxishuliang':'Number of messages',
    'key_xiangmuyunweizongrenshu':'Project operations',
    'key_gongdandaichulishuliang':'Work order to be processed',
    'key_shebeibaojingshuliang':'Alarm number of equipment',
    'key_shebeilixianshuliang':'Offline number of devices',
    'key_qingshuruguanjianzi':'Please enter keywords to search',
    'key_zonggongjiedian':'总共节电',
    'Key_jieyueyongdian':'节约用电',
    'key_yunweirenjunengxiaotisheng':'运维人均能效提升',
    'key_zhongyangkongtiaozongjienenglv':'全部应用中央空调总节能率',
    'key_bingxulengzongjienenglv':'全部应用冰蓄冷总节能率',
    'key_quanbuyingyongpingjungongdan':'全部应用平均工单响应时间'
}

//设备管理
//1.设备总览
const deviceoverviewLang = {
    'key_shebeizonglan':'Device overview',
    'key_shebeizongshuUnit':'Device total amount',
    'key_jinrituisongxiaoxishu':'Messages pushed(today)',
    'key_jinrixiafaminglingshu':'Orders assigned(today)',
    'key_jinrixinzengshebeishu':'New devices amout(today)',

    //引用公用类
    'key_shebeizongtiqingkuangfenxi':'Overall situation analysis',
    'key_gexitongshebeiguzhangqushitu':'Devices failures tendency',
    'key_qingxuanzeshebeileixing':'Please select device type',

    //系统分类菜单
    'key_quanbuzailixianzhuangtai':'All online/offline status',
    'key_quanbubaojingzhuangtai':'All alarm status',
    'key_baojingzhong':'In alarm',
    'key_zaixianzhuangtai':'Online status',
    'key_jingbaozhuangtai':'Alarm status',
    'key_zutaiyemian':'Configuration page',
    'key_caozuozhuangtai':'Operation status',
    'key_diaoru':'Call in',
    'key_yaunchengkongzhi':'Remote control ',
    'key_kaiguan':'ON/OFF',
    'key_dingshikai':'Timer ON',
    'key_dingshiguan':'Timer OFF',
    
    //设备详情
    'key_shebeixiangqing':'Equipment details',
    'key_jichuxinxi':'Basic information',
    'key_suoshuleixing':'Belongs to type', 
    'key_ruwangshijian':'The net time',
    'key_shebeiID':'Device ID ',
    'key_shebeizhandian':'Equipment to the site',
    'key_xuliehao':'Serie number',
    'key_shebeierweima':'QR code for equipment',
    'key_shebeidangan':'equipment archives',
    'key_zhixingjieguo':'result of execution',
    'key_zerenren':'duty officer',
}

//能耗管理
const energyConsumLang = {
    //1.总能耗统计
    'key_nenghaofenbu':'Consumption Distribution',
    'key_zongnenghaotongji':'Total energy consumption statistic',
    'key_yiji':'First',
    'key_suoxuan':'Selected',
    'key_quyunenghaoxiaofeiqingkuang':' area energy consumption',
    'key_shuifeizonglan':'Water',
    'key_dianfeizonglan':'Electricity',
    
    //2.用水统计
    'key_yongshuitongji':'Water consumption',
    'key_tongjifangshi':'Statistic Methods',
    'key_anfeiyong':'By cost',
    'key_anyongliang':'By usage',

    //2.用电统计
    'key_yongdiantongji':'electricity consumption',
    'key_quedingyaoshanchu':'Are you sure you want to delete ',
    'key_dangqianjigouxiayouzijigou':'There are sub-mechanism Settings under the current mechanism. After the execution of deletion, all of them will be deleted and cannot be restored. Do you still want to delete them'
  
}

//报警管理 
const alarmManagementLang = {
    //1.实时报警
    'key_baojingliebiao':'Alarm List',
    'key_shebeibaojing':'Device Alarm',
    'key_shebeiyujing':'Device Prewarning',
    'key_yuxingyujing':'Operational Prewarning',
    'key_chulizhuangtai':'Treatment Status',
    'key_baojingjibie':'Alarm Level',
    'key_chanpinleixing':'Product Type',   
    'key_baojingshijian':'Alarm Time',
    'key_baojingneirong':'Alarm Content',
    'key_shebeimingcheng':'Device Name',
    'key_shebeiweizhi':'Device Position',
    'key_chiixushijian':'Duration',
    
    //2.报警分析

    'key_baojingfenxi':'Alarm Analyse',
    'key_baojingleixingfenxi':'Alarm Type analysis',
    'key_baojingpinjunchixushijian':'Alarms average duration',
    'key_baojinghuodongfenbu':'Alarm activities distribution',
    'key_leijishebeibaojingshu':'Device alarms',
    'key_leijishebeiyujingshu':'Device prewarning',
    'key_leijiyunxingyujingshu':'Operational prewarning',
    'key_baojingshu':' Alarm Amount',
    
    //3.报警定义
    'key_baojingdingyi':'Alarm Definition',
}

//维保管理 
const maintenanceManagementLang = {
    //1.报警分析
    'key_weibaofenxi':'Maintenance Analyse', 
    'key_gongdantongji':'Order statistics', 
    'key_quanbuweibaoleixing':'All Maintenance Type', 
    'key_weiwaiweixiu':'Outsource Maintenance', 
    'key_weiwaijigai':'Outsource Technical Renovation', 
    'key_dianxunjian':'Spot/Routing Inspection', 
    'key_yuangongshangbao':'Employee Reporting', 
    'key_gongdanzongshu':'Order total amount', 
    'key_yichuligongdanshu':'Order(processed)', 
    'key_pingjungongdanchulishijian':'Average Order Processing Time',    
    'key_gongdantongjiqushitu':'Order Statistical Trend Map', 
    'key_gongdanchulijieguotongji':'Statistics of Work Order Processing Results', 
    'key_yuangongchuligongdan':'Employee Processing Order Enthusiasm Rank', 
    'key_paiming':'Rank', 
    'key_gongdanchulilv':'Work order processing rate', 
    
    //2.当前任务
    'key_dangqianrenwu':'Current Task', 
    'key_anweibaorenyuansousuo':'Search by Maintenance Target/Device Position/Assignee',
    'key_gongdanID':'Work order ID',
    'key_dongdanmingcheng':'Name of the repair order',
    'key_zuixinrenwubeizhu':'Latest task notes',
    'key_zuixinchulijieguo':'Latest processing results',
    'key_fenpeigongdan':'Distribution of work order',
    'key_peijianzhong':'In the accessories',
    'key_weixiuzhong':'In maintenance',     
    'key_weibaoduixiang':'Maintenance Target', 
    'key_weibaoleixing':'Maintenance Type', 
    'key_weibaoneirong':'Maintenance Content', 
    'key_fenpeizhi':'Distributed to', 
    'key_renwubeizhu':'Task Remark', 
    'key_faqishijian':'Start Time', 
    'key_wanchengshijian':'End Time', 
    'key_gongdanchuliliu':'Work order processing flow' ,
    'key_zuixinfenpeizhi':'Latest allocation to',
    'key_weibaogongdan': 'Maintenance work order',
    'key_dianjianxunjian': 'Spot/Routing Inspection',
    'key_baoxiu':'repairs',
    'key_quanbugongdan':'All the work order',
    'key_bukefenpei':'Cannot be assigned',
    'key_kefenpei':'Dispensability',
    'key_daizhixing':'To perform',

    //工单详情
    'key_gongdanxiangqing':'Order Detail', 
    'key_tijiaoren':'Submitter', 
    'key_tijiaorenlianxifangshi':'Submitter\'s phonenumber', 
    
    //3.维保历史
    'key_weibaolishi':'Maintenance History', 
    'key_quanbuchulijieguo':'All processing results', 
    'key_tiaoshichenggong':'Adjusteed', 
    'key_wubao':'Misreport', 
    'key_chulijieguo':'Processing results', 
    
    //4.点检巡检
    'key_anjihuamingchengsousuo':'Search by task name', 
    'key_jihuamingcheng':'Task Name', 
    'key_xinzengdianxunjianjihua':'Add Spot/Routing Inspection Plan',
    'key_bianjidianxunjianjihua':'Edit Spot/Routing Inspection Plan',
    'key_zhixingzhuangtai':'Status',
    'key_zhixing':'Implement',
    'key_quxiaozhixing':'Call off',
    'key_xuanzedianjianfanwei':'Select spot inspection area', 
    'key_xuanzedianjianleimu':'Select spot inspection category', 
    'key_xuanzeweihuxiang':'Select maintenance target', 
    'key_zhixingshijian':'Implement time', 
    'key_yuxuanze':'Select Area',    
    'key_dianjianren':'Maintenance staff',     
    'key_weihuxiang':'Maintenance target', 
    'key_jizhun':'Standard', 
    'key_xunjianquyu':'Routing inspection area', 
    
    //5.委外技改
    'key_weiwaigongdan':'Outsource Order',
    'key_quanburenwuleixing':'All task type', 
    'key_quanbugongdanzhuangtai':'All order status',  
    'key_daigenjin':'Undertaken', 
    'key_genjinzhong':'Processing', 
    'key_yiwancheng':'Finished', 
    'key_renwuleixing':'Task type', 
    'key_gongdanzhuangtai':'Order status', 
    'key_baojingxinxi':'Alarm info', 
    'key_gongdanbeizhu':'Order remark', 
    'key_dianjian':'Spot inspection', 
    'key_xunjian':'Routing inspection', 
    'key_kancha':'Survey', 
    'key_anweibaoduixiang/shebeiweizhisousuo':'Search by Maintenance Object/Device Location/Assignee',
    
    //6.报警任务分配
    'key_baojingrenwufenpei':'Alarm Task Distribute', 
    'key_anshebeimingchengsousuo':'Search by device name/assignee', 
    'key_zuihoubianjishijian':'Last edit time', 

    //7.日常报事
    'key_richangbaoshi':'Daily Routine',
    'key_daifenpei':'To Be Assigned',
    'key_yifenpei':'Assigned',
    'key_baoshineirong':'The matter content',
    'key_baoshiwentixiangqing':'The matter details',
    'key_antijaoren':'Search by submitter/submitter contact/distributor',
    'key_antijiao':'Search by submitter/submitter contact',
    'key_tijiaobumen':'提交部门',
    'key_qingshurubeizhujianyi100zi':'请输入备注建议（100字以内）',
    'key_beizhujianyi':'备注建议',
    'key_caozuochenggong':'操作成功'
}

//运维通知
const noticeManagementLang = {
    //1.发布历史
    'key_fabulishi': 'Notice History',
    'key_fabu': 'Publish',
    'key_fabuxintongzhi': 'Release Notice',
    'key_tongzhizhuti': 'Notice Theme',
    'key_tongzhineirong': 'Notice Content',
    'key_luokuanneirong': 'Inscription Content',
    'key_fabushijian': 'Release Time',
    'key_noticeWarning': 'Notice will sent to all App users after released',   
    'key_fabuchenggong':'Release successful',
   
}
const news = {
    'key_xinwenliebiao':'News list',
    'key_fabuxinwen':'release news',
    'key_liulancishu':'view count',
    'key_xinwenzhuti':'news topic',
    'key_xinwenneirong':'News Content',
    'key_xinwenluesuotu':'News thumbnail',
    'key_tupian3m':'Pictures up to 3M, support. JPG,. Jpeg,. PNG format',
    'key_shangchuantupiangeshi':'Upload image can only be JPG/JPEG/PNG format!',
    'key_tupianbunengchaochu':'The image size cannot exceed 3MB!'
}
//系统配置
const systemSettinManagementLang = {
    //1.组织架构配置
    'key_zuzhijiagoupeizhi': 'Organizational Structure',
    'key_daoruzuzhijiagou': 'Import Organizational Structure',
    'key_xinjianzijigou': 'Create ',
    'key_xinjiantongjijigou': 'New Institutions(same level)',   
    'key_kongjianpeizhi': 'Space Config',

    //3.岗位类型配置
    'key_gangweileixingpeizhi': 'Position Type Config',
    'key_xinjiangangweileixing': 'New Position Type',
    'key_bianjigangweileixing': 'Edit Position Type',
    'key_gangweileixingmingcheng': 'Position Name',
    'key_peizhishijian': 'Config Time',
    
    //4.水电费配置
    'key_shuidianfeipeizhi': 'Water/Electricity Rates Config',
    'key_dianfeipeizhi': 'Electricity Rates Config',
    'key_shuifeipeizhi': 'Water Rates Config',   
    'key_gengxinpeizhitiaojian': 'Update Configure Condition',
    'key_tiaozhengdanjia': 'Change Cost',
    'key_danjia': 'Price',
    'key_shiduan': 'Timerange',
    'key_digu': 'Trough hour',
    'key_pingduan': 'Flat hour',
    'key_gaofeng': 'Rush hour',
    'key_jianfeng': 'Peak hour',
    'key_jianfengyuefenshezhi': 'Set peak month',
    'key_dianyajijiaqujian': 'Electricity valuation interval',
    'key_quanshiduan': 'All time-range',
    'key_peizhichenggong':'Configuration is successful',
    'key_suoyouxianweibitian':'All items are required',
    'key_xuanzeyigehuoduogeyue':'Select one or more months',
    'key_qingxiangengxinpeizhitiaojian':'Please update the configuration conditions first'
}

//个人设置
const personalSettingLang = {
    //更改公司信息
    'key_genggaigongsixinxi': 'Change Company Info',
    'key_gongsixinxi':'Company Info',
    'key_suozaiquyu':'Location area',
    'key_gexingshezhitishi1': 'If company info has been changed,please Email to',
    'key_gexingshezhitishi2': 'We will contact you to confirm information as soon as we recieve Email',
    
    //个性配置
    'key_pingtailogo': 'Plantform Logo',
    'key_xuanzepingtaizhusediao': 'Choose Plantform Color',
    'key_shebeijierupingtaimingcheng': 'Console\'s Name',
    'key_dapingxianshimingcheng': 'BigScreen Name',
    'key_qingshurupingtaimingcheng':'Please enter platform name',
    'key_15zifuyinei':'Less than 15 characters',
    'key_10zifuyinei':'Less than 10 characters',
    'key_18zifuyinei':'Less than 18 characters',
    'key_tupianzhinengweiPNGgeshi':'Pictures can only be in PNG format!',
    'key_tupiandaxiao3M':'Picture size should not exceed 3MB!',
    'key_tupiankuangaowei38*38':'The width and height of the picture must be 38*38!',
    'key_gexingshezhitishi3': 'Image\'s scale require 38*38 pixles,format require PNG only ',

}

// 员工管理和后台用户
const staffManagement = {
   //角色
    'key_APPgongnengquanxianliebiao':'APP Functional Permission List',
    'key_dibudaohang':'Bottom navigation',
    'key_duiyingzicaidan':'Corresponding Submenu',
    'key_peizhigongneng':'+ Configuration function',
    'key_xuanzepeizhimokuai':'Select Configuration Module',
    'key_dibuxuanzemokuaitishi1':'Select at least 2 modules for bottom navigation',
    'key_dibuxuanzemokuaitishi2':'Select up to 5 modules for bottom navigation',
    'key_piliangshanchu':'Batch Remove',
    'key_houtaiyonghu':'Enterprise User',
    'key_youxiang':'Email',
    'key_juese':'Role',
    'key_yonghudenglumima':'User login password',
    'key_qingshuruyonghudenglumima':'Please enter user login password',
    'key_xinjianzhanghu':'Create new account ',
    'key_bianjizhanghu':'Edit account',
    'key_shifouyaoshanchugaizhanghu':'Are you sure you want to delete this account?',  
    'zhanghu':'Account',
    'key_querenjinyongma':'Are you sure you want to disable this account?',
    'key_querenqiyongma':'Are you sure you want to enable this account?', 
    'key_jinyongchenggong':'operate successfully!',
    'key_qiyongchenggong':'operate successfully!',
    'key_zhanghuxinxi':'Account information',
    'key_qingxuanzejuese':'Please select role',
    'key_yuangongliebiao': 'User List',
    'key_jiansuotiaojian': 'Condition',
    'key_yuangonggonghao': 'User Id',
    'key_xingming': 'Name',
    'key_gangweileixing':'Post type',
    'key_renliancaijizhuangtai': 'Facial Identity Status',
    'key_quanbu': 'All',
    'key_yicaiji': 'Completed',
    'key_weicaiji': 'Incompleted',
    'key_yuangongxingming': 'User Name',
    'key_gongzuoquyu':'Working Area',
    'key_renzhengzhuangtai': 'Gate Control',
    'key_yirenzheng': 'Verified',
    'key_weirenzheng': 'Not Verified',
    'key_renzhengzhong': 'Verifying',
    'key_renzhengshibai': 'Verifying failed',
    'key_sousuo': 'Search',
    'key_xinjian': 'Create',
    'key_bianji': 'Edit',
    'key_shanchu': 'Delete',
    'key_daochushuju': 'export data',
    'key_zhongwenxingming': 'User Name',
    'key_xingbie': 'Gender',
    'key_zaizhizhuangtai': 'Status',
    'key_shoujihaoma': 'Mobile Phone',
    'key_suoshubumen': 'Location',
    'key_bangongdidian': 'Area',
    'key_caozuo': 'Operation',
    'key_gong': 'Total',
    'key_ye': 'Pages',
    'key_tiaoshuju': 'records',
    'key_meiyexianshi': 'Records Per Page',
    'key_zaizhi': 'Valid',
    'key_lizhi': 'Not Valid',
    'key_yuangongxinxi': 'Employee information',
    'key_riqi':'date',
    'key_tongxingjilu':'Access records',
    'key_qingxuanzeyuangonghouzaijinxingshanchu': 'Please select at least one item before deleting it!',
    'key_shifouyaoshanchusuoxuanyuangong': 'Do you want to delete the selected employees?',
    'key_tishi': 'Tips',
    'key_queding': 'Confirm',
    'key_quxiao': 'Cancel',
    'key_shanchuyuangong': 'Delete staff',
    'key_daochuyuangong': 'Export staff',
    'key_daoruyuangong': 'Import staff',
    'key_jinengbiaoqian':'Skills label',
    'key_shizifuyinei':'Less than 10 characters',
    'key_xingmingshoujihaoyouxiang':'Search by name/phone number/email'
}

// 新建/编辑员工
const newStaff = {
    'key_xinjianyuangong': 'Create User',
    'key_bianjiyuangong': 'Editing User',
    'key_jibenxinxi': 'Basic Information',
    'key_suoshuzuzhi': 'Organization',
    'key_yingwenmingzi': 'User Name',
    'key_xingbie': 'Gender',
    'key_nan': 'Male',
    'key_nv': 'Female',
    'key_gangwei': 'Post',
    'key_yuangongleixing': 'Employee Type',
    'key_ruzhiriqi': 'Enrollment Date',
    'key_gerenyouxiang': 'Personal Email',
    'key_APPmima': 'User App Password',
    'key_8~16weishuzi,zimuhunhe': '8~16 numbers and characters',
    'key_zaicishurumima': 'Confirm Password',
    'key_renzhengxinxi': 'Verification Infotmation',
    'key_renlianxinxi': 'Facial Identity Status',
    'key_menjinrenzheng': 'Gate Control',
    'key_baocun': 'Save',
    'key_quxiao': 'Cancel',
    'key_fanhui': 'Return',   
    'key_yingwenxingming': 'English name',
    'key_quanzhizhengshiyuangong': 'Regular employee',
    'key_jianzhiyuangong': 'Part-time employees',
    'key_xuanzeriqi': 'Select Date',
    'key_qingshuruyuangongweiyihao': 'Please enter the employee unique number.',
    'key_qingxuanzezaizhizhuangtai': 'Please select on-the-job status.',
    'key_qingshurushoujihaoma': 'Please enter  mobile phone number',
    'key_qingshurugerenyouxiang': 'Please enter email address',
    'key_qingshuruAPPmima': 'Please enter APP password ',
    'key_qingzaicishurumima': 'Please enter the password again',
    'key_qingxuanzegongzuoquyu':'Please select work area',
    'key_qingshuruyuangonggonghao':'Please enter employee id (pure number)',
    'key_qingshuruxingming':'Please enter name',
    'key_bumen':'department',
    'key_shoujihaobunengweikong':'Cell phone number cannot be empty',
    'key_qingshuruzhengquedeshoujihao':'Please enter the correct phone number',
    'key_qingshuruchunshuzi':'Please enter the pure number of the employee',
    'key_yungonggonghaobunengweikong':'Employee number cannot be empty',
    'key_qingxuanzesuosubumen':'Please select your department',
    'key_qingxuanzegongzuoquyu':'Please select work area',
    'key_qingxuanzegangweileixing':'Please select the position type',
    'key_qingxuanzeyuangong':'Please select employees',
    'key_qingshurushoujihao': 'Please enter your cell phone number.',
    'key_qingshuruzhengquedeyouxiang': 'Please enter the correct mailbox.',
    'key_qingshuruzhongwenxingming': 'Please enter your User name.',
    'key_qingshurumima': 'Please input a password.',
    'key_qingchongfushurumima': 'Please repeat your password.',     
    'key_liangcishurudemimabuyizhi': 'The password and confirmation password are different',
    'key_tianjiachenggong': 'Creating successfully',
    'key_bianjichenggong': 'Editorial successful',
    'key_fenpeichenggong': 'Distribution of success',
    'key_xinjianyuangong': 'Create User',
    'key_jibenxinxi': 'Basic Information',
    'key_suoshuzuzhi': 'Organization',
    'key_yingwenmingzi': 'User Name',
    'key_xingbie': 'Gender',
    'key_nan': 'Male',
    'key_nv': 'Female',
    'key_gangwei': 'Post',
    'key_yuangongleixing': 'Employee Type',
    'key_ruzhiriqi': 'Enrollment Date',
    'key_gerenyouxiang': 'Personal Email',
    'key_APPmima': 'User App Password',
    'key_8~16weishuzi,zimuhunhe': '8~16 numbers and characters',
    'key_zaicishurumima': 'Confirm Password',
    'key_renzhengxinxi': 'Verification Infotmation',
    'key_renlianxinxi': 'Facial Identity Status',
    'key_menjinrenzheng': 'Gate Control',
    'key_baocun': 'Save',
    'key_quxiao': 'Cancel',
    'key_fanhui': 'Return',
    'key_bianjiyuangong': 'Editing User',
    'key_yingwenxingming': 'English name',
    'key_quanzhizhengshiyuangong': 'Regular employee',
    'key_jianzhiyuangong': 'Part-time employees',
    'key_xuanzeriqi': 'Select Date',
    'key_qingshuruyuangongweiyihao': 'Please enter the employee unique number.',
    'key_qingxuanzezaizhizhuangtai': 'Please select on-the-job status.',
    'key_qingshurushoujihaoma': 'Please enter your mobile phone number',
    'key_qingshurugerenyouxiang': 'Please enter your personal email address',
    'key_qingshuruAPPmima': 'Please Enter APP Password ',
    'key_qingzaicishurumima': 'Please enter your APP password',
    'key_qingxuanzegongzuoquyu':'Please select work area',
    'key_qingshuruyuangonggonghao':'Please enter employee id (pure number)',
    'key_qingshuruxingming':'Please enter name',
    'key_bumen':'department',
    'key_shoujihaobunengweikong':'Cell phone number cannot be empty',
    'key_qingshuruzhengquedeshoujihao':'Please enter the correct phone number',
    'key_qingshuruchunshuzi':'Please enter the pure number of the employee',
    'key_yungonggonghaobunengweikong':'Employee number cannot be empty',
    'key_qingxuanzesuosubumen':'Please select your department',
    'key_qingxuanzegongzuoquyu':'Please select work area',
    'key_qingshurushoujihao': 'Please enter your cell phone number.',
    'key_qingshuruzhengquedeyouxiang': 'Please enter the correct mailbox.',
    'key_qingshuruzhongwenxingming': 'Please enter your User name.',
    'key_qingshurumima': 'Please input a password.',
    'key_qingchongfushurumima': 'Please repeat your password.',
    'key_bianjiyuangongchenggong': 'Editorial staff successful',   
    'key_liangcishurudemimabuyizhi': 'The password and confirmation password are different',
    'key_tianjiayuangongchenggong': 'Employee added successfully'
}

// 员工授权记录
const empowerPeople = {
    'key_shebeimingcheng': 'Device Name',
    'key_shouquanzhuangtai': 'Authorization Status',
    'key_shebeibianhao': 'Device Id',
    'key_quyubianhao': 'Location',
    'key_bangongshibianhao': 'Area',
    'key_chuangjianshijian': 'Create Date',
    'key_yishouquan': 'Allowed',
    'key_jujue': 'Denied',
    'key_weishouquan': 'Unauthorized'
}

// 访客管理
const visitorManagement = {       
    'key_fangkeguanli':'Visitor management',
    'key_shenqingren':'Proposer',
    'key_shenqingriqi':'Application date',
    'key_fangkelianluoren':'Visitor contact',
    'key_fangkeleixing':'Visitors to type',
    'key_fangkexingchengID':'Visitor itinerary ID',
    'key_jiedairen':'Receiver',
    'key_kaishishijian':'Start time',
    'key_jieshushijian':'End time',
    'key_fangkerenshu':'Visitor count',
    'key_laifangmudi':'Purpose of visit ',
    'key_shenqingrenxinxi':'Applicant information',
    //查看访客行程
    'key_fangkexingchengxinxi':'Visitor itinerary information',
    'key_fangkexingcheng':'View visitor itinerary',
    'key_jiedairenshoujihaoma':'Reception of mobile phone number',
    'key_fangkeshoujihao':"Visitor's mobile phone number",
    'key_fangkezhengjian':'Type of visitor id',
    'key_zhengjianhaoma':'ID Number',
    'key_laikerenshu':'The number of the guest',
    'key_chepaihao':'license plate number ',
    'key_shifouxianshihuanyingci':'Whether the welcome message is displayed',
    'key_huanyingci':'Welcome and introduction',
    'key_fangkezidongzhongduan':'Automatic visitor terminal',
    'key_caijifangkexinxi':'Collect visitor itinerary',
    'key_fangkexingming':"The visitor's name",
    'key_fangkezhaopian':'Visitors photographs',
    'key_weikaishi':'NotStarted',
    'key_jinxingzhong':'Underway ',
    'key_yijieshu':'Finished',
    'key_caijifangkerenshu':'Number of visitors',
    'key_shenfenzheng':'ID card',
    'key_jiluId': 'Record Id',
    // 访客认证记录
    'key_fangkeleixing': 'Visitors to type',
    'key_xingchengID': 'Trip ID',
    'key_tongxingfangshi':'Passage way',
    'key_diyicitongxingshijian':'First pass time',
    'key_zuihouyicitongxingshijian':'Last pass time',
    'key_anshenqingrenfangkelianluorensousuo':'Search by applicant/visitor contact',
    'key_yuyuefangke':'Making an Appointment',
    'key_yaoyuefangke':'Invite visitors'
}




// 会议室管理
const conferenceRoomManagement = {
    'el.cascader.noData':'No Data',
    'key_huiyishiID': 'Room ID',
    'key_chuanjianren':'Creator',
    'key_huiyishimingcheng': 'Room name',
    'key_huiyishiweizhi': 'Conference room location',
    'key_dangqianzhuangtai': 'Current status',
    'key_anhuiyishisheshisousuo':'Search by conference room name/facility configuration',
    'key_kongxian': 'Leisure ',
    'key_shiyongzhong': 'In use',
    'key_peizhisheshi': 'Configuration facilities',
    'key_huiyishibianhao': 'Room number',
    'key_sheshipeizhi': 'Facility layout',
    'key_shifouqiyong':'Whether to enable',
    // 新建会议室
    'key_qingshuruhuiyishimingcheng':'Please enter the name of the conference room（within the 15 characters limit）',
    'key_qingxuanzehuiyishiweizhi':'Please select the location of the conference room',
    'key_shezhiyudingshijian':'Set scheduled time',
    'key_huiyishikeyudingshijian':'The conference room can be booked',
    'key_qingshuruzhengzhengshu':'Please enter an integer number',
    'key_huiyiyuyuexiangqing':'Appointment details',
    'key_shifouyaoshanchugaihuiyishi':'After deletion, this conference room will not be available. Please confirm whether it is deleted or not？',
    'key_shezhichenggong':'Successfully set',
    // 预约详情
    'key_xinjianhuiyishi': 'New conference room',
    'key_bianjihuiyishi': 'Editing conference room',
    'key_huiyishixinxi': 'Conference room information',
    'key_yuyuexiangqing': 'Booking details',
    'key_shiyongzhe': 'User',
    'key_suoshugongsi': 'subordinate companies ',
    'key_yuyueren':'Booking person',
    'key_yuhuizhe':'Conventioner',
    'key_huiyimudi':'Conference purpose',
    'key_weikaishi':'NotStarted',
    'key_shiyongzhong':'Occupied',
    'key_shiyongwancheng':'Use complete',
    'key_quxiao_weishiyong':'Cancel (not in use)',
    'key_quxiao_tiqianshifang':'cancel (early release)',
    'key_quxiao_yiguoqi':'Cancel (expired)',
}


// 工位管理
const locationManagement = {
    'key_gongweiguanli':'工位管理',
    'key_gongweimingcheng': '工位名称',
    'key_gongweibianhao': '工位编号',
    'key_bangongshimingcheng': '办公室名称',
    'key_xinjiangongwei': '新建工位',
    'key_bianjigongwei':'编辑工位',
    'key_gongweiweizhi':'工位位置',
    'key_angongweimingchengsheshisousuo':'按工位名称/配置设施搜索',
    'key_qingxuangongweiweizhi':'请选择工位位置',
    'key_qingshurugongweimingcheng':'请输入工位名称（20字以内）',
    'key_qingxuanzegongweiweizhi':'请选择工位位置',
    'key_gongweixinxi':'工位信息',
    'key_gongweixiangqing':'工位详情',
    'key_yuyuerenshoujihao':'预约人手机号',
    'key_yuyueshijian':'预约时间',
    'key_shifouyaoshanchugaigongwei':'确定要删除该工位吗?',
    'key_gongweiikeyudingshijian':'工位可预定时间',
    'key_shezhigongweihuanjingcelue':'设置工位环境策略',
    'key_shezhihuanjingcelue':'设置工位环境策略',
    'key_qiandao':'签到',
    'key_jieshushiyong':'结束使用',
    'key_likai':'离开',
    'key_yiquxiao':'已取消',
    'key_qingxuanzewangguan':'请选择网关',
    'key_qingxuanzeshebei':'请选择设备',
    'key_guanlianshebei':'关联设备',
    'key_shiyongzhe':'使用人/预约人',
    'key_keyuyue':'可预约',
    'key_yiyuyue':'已预约',
    'key_yizhanyong':'已占用',
    'key_bukeyong':'不可用',

    // 工位智能设备
    'key_gongweishebeiguanli':'工位设备管理',
    'key_tianjiawangguan-shebei':'添加网关-设备',
    'key_wangguanzhuangtai':'网关状态',
    'key_anwanggguanimingchengdizhisousuo':'按网关名称/网关地址搜索',
    'key_tianjiashijian':'添加时间',
    'key_wangguansheibeishu':'网关设备数',
    'key_wangguanzhuangtai':'网关状态',
    'key_wangguandizhi':'网关地址',
    'key_wangguanmingcheng':'网关名称',
    'key_wangguanweizhi':'网关位置',
    'key_chakanwangguanshebei':'查看网关设备',
    'key_xinjianwangguanshebei':'新建网关设备',
    'key_bianjiwangguanshebei':'编辑网关设备',
    'key_qingshurubeizhu100zi':'请输入备注（100字以内）',
    'key_qingshuruwangguandizhi':'请输入网关地址',
    'key_qingshuruwangguanmingcheng':'请输入网关名称',
    'key_qingxuanzewangguanweizhi':'请选择网关位置',

    //停车场管理
    'key_tingchechangmingcheng':'Parking Name',
    'key_tingchechangguanli':'Parking Management',
    'key_tingchechangtupian':'Parking lot picture',
    'key_qingshurutingchechangmingcheng':'Please enter the name of the parking lot',
    'key_tingchechangtupianyanzheng':'大小不超过3M，图片格式为.jpg、.jpeg、.png、.gif',
    'key_qingshangchuantingchechangtupian':'Please upload pictures of parking lot',

    //车位管理
    'key_gudingcheweiguanli':'Fixed parking Management',
    'key_fangkecheweiguanli':'Visitor parking Management ',
    'key_shouquanzhong':'Authorizing',
    'key_shoujihaoxingmingchepaihao':'Mobile/Plate/Name ',
    'key_fangkelianxirenfangkeshoujihaochepaihao':'Visitor name/Visitor mobile/Plate',
    'key_shoujihao':'Mobile',
    'key_fangshi':'Avenue',
    'key_shouquanchewei':'Authorize parking',
    'key_shouquan':'Authorize',
    'key_quxiaoshouquan':'Cancel authorization',
    
    'key_jiedairenshoujihao':'Receptionist mobile',
    'key_fangkelianxiren':'Visitor name',
    'key_mudi':'Purpose',
    'key_tongyi':'approve',
    'key_jujue':'Refused',
    'key_tijiaoshijian':'Submission time',
    'key_beizhu':'Remark',
    'key_daishenhe':'To be verified',
    'key_shenhezhong':'Verifying',
    'key_yitongyi':'Approved',
    'key_yijujue':'Refused',
    'key_chepaihao':'Plate number',
    'key_shouquanshijian':'Authorized period',
    'key_dangqianchepaihao':'Plate number',
    'key_shifouquedingjujuegaichepaihao':'Are you sure you want to rufuse authorizing this plate?',
    'key_shifouquedingquxiaoshouquan':'Are you sure you want to cancel authorizing this plate?',
    'key_shifouquedingshanchugaichepaihao':'Are you sure you want to delete this plate?',
    'key_APPtijiao':'APP submitted',
    'key_houtaichuangjian':'Platform created',
    'key_xiangqing':'Detail',
    'key_qingshuruchepaihao':'Please input plate number',
    'key_ruchangshijian':'Enter time',
    'key_chuchangshijian':'Exit time',
    'key_tingcheshichang':'Parking time',
    'key_cheliangleixing':'Car type',
    'key_chepaihaoxingming':'Plate number/name',
    'key_gudingchewei':'Fixed parking',
    'key_fangkechewei':'Visitor parking',
    'key_qitachewei':'Others',
    'key_quxiaozhong':'Canceling',
    'key_shouquanshibai':'Authorize failed',
}



// 设备管理
const deviceManagement = {
  'key_shebeiguanli': 'Device Management',
  'key_shebeizhuangtai': 'Device Status',
  'key_beizhu': 'Description',
  'key_zhengchang': 'Normal',
  'key_shilian': 'missing'
}

// 通用设置
const generalSettings = {
  'key_tongyongshezhi': 'Settings',
  'key_xianshishijianshezhi': 'Display time settings',
  'key_huanyingpingtiqianxianshishijian': 'Welcome screen display time in advance (Minutes)',
  'key_huanyingpingyanhoujieshuxianshishijian': 'Welcome Screen Delayed End Display Time (Minutes)',
  'key_huiyishitiqianxianshishijian': '会议室提前显示时间（分钟）',
  'key_huiyishiyanhouxianshishijian': '会议室延后显示时间（分钟）',
  'key_gongweitiqianxianshishijian': '工位提前显示时间（分钟）',
  'key_jienengshijianshezhi': 'Background map of Welcome Screen settings',
  'key_huiyishitiqianganyingshijian': '会议室提前感应时间（分钟）',
  'key_gongweiqishenganyingshijian': '工位起身感应时间（分钟）',
  'key_huanyingpingbeijingshezhi': 'Background map of Welcome Screen settings',
  'key_tupianchicunwei19201200JPGPNGgeshi': 'Image size 1920*1200,JPG/PNG format',
  'key_shangchuantupian': 'Upload pictures',
  'key_tijiao': 'Submit',
  'key_tupianshangchuanchenggong': 'Picture uploaded successfully',
  'key_baocunchenggong': 'save successfully',
  'key_baocunshibai': 'Save failed',
  'key_shangchuangeshijinweiAPKdaxiao100MB': 'Upload format is APK only,less than 100MB',
  'key_dangqianxianzhixuanze3gewenjianbencixuanzele': 'Currently limited to 3 files selected, selected this time',
  'key_gewenjiangongxuanzele': 'files, all selected',
  'key_gewenjian': 'files',
  'key_yonghuanzhuangbao': 'Portal Application Installation Package',
  'key_fangkerenzhengshenqinganzhuangbao': 'Visitor Certification Application Installation Package',
  'key_quedingyichu': 'Confirm removal',
  'key_jiangwenjiantuodaocichuhuo': 'Drag the file here, or ',
  'key_dianjishangchuan': 'Click to upload',
  'key_anzhuangbaoshezhi': 'Installation package settings',
  'key_shangchuanshijian': 'Update time',
  'key_dangqianbanben': 'Current version',
  'key_dianjitupianshangchuan': 'Click Image upload',
  'key_shangchuanchenggong': 'Successful upload',
  'key_shangchuanshibaibanbenguicecuowu': 'upload failed,Version rules error !'
}

// 其他
const rests = {
    'key_jinggao': 'warning',
    'key_qingxuanzeshijianduan': 'Please select time period',
    'key_shi': 'Yes',
    'key_fou': 'NO',
    'key_lianjiechaoshi': 'Connection timed out',
    'key_yuyan': 'Language',
    'key_zhongwen': 'Chinese',
    'key_yingwen': 'English'
}

// 角色
const roleList = {   
    'key_juese':'Role',
    'key_zhuangtai':'Status',
    'key_anjuesemingchengsousuo':'Search by role name',
    'key_juesemingcheng':'Role Name',
    'key_qingshurujuesemingcheng':'Please enter role name (within 15 characters)',
    'key_qingshurujuesemingcheng1':'Please enter role name',
    'key_qingshurujuesemiaoshu':'Please enter role description (within 30 characters)',
    'key_juesemiaoshu':'Role Description', 
    'key_xinjianjuese':'Create Role',
    'key_qiyong':'Enabled',
    'key_jinyong':'Disabled',
    'key_bianji':'Edit',
    'key_peizhiquanxian':'Configure permissions',
    'key_querenjinyongjuesema':'Are you sure you want to disable this role?',
    'key_querenqiyongjuesema':'Are you sure you want to enable this role?',
    'key_shifouyaoshanchugaijuese':'Are you sure you want to delete the role?',
    'key_juesexinxi':'Role Information',
    'key_shuoming':'Note: select enterprise application on the left (multiple options are available), and on the right is its corresponding function permission configuration.',
    'key_xuanzeyingyong':'selected applications',
    'key_duiyinggongnengquanxian':'Corresponding function permissions',
    'key_peizhiquanxianchenggong':'successfully',
    'key_qingxuanzeyingyong':'Please select application',
    'key_qingxuanzequanxian':'Please select permissions',
    "key_zanwuyingyongqingxianjian":'No application, please create new application!'
    
}

export default {
    login,  //登录
    headerLang,   //头部导航栏
    Aside,  //左侧导航栏
    common, //公用
    projectOverviewLang,  //项目概览
    deviceoverviewLang, //设备管理
    energyConsumLang, //能耗管理
    alarmManagementLang,//报警管理 
    maintenanceManagementLang,//维保管理
    noticeManagementLang,//运维通知
    systemSettinManagementLang,//系统配置
    personalSettingLang,//个人中心
    news,
    staffManagement,
    newStaff,
    empowerPeople,
    visitorManagement,
    conferenceRoomManagement,
    locationManagement,
    generalSettings,
    deviceManagement,
    rests,
    roleList
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js